export function Mapdata(data, id) {
  const testBody = {
    $type:
      'FinancingSystemDefinitions.Common.WebApiResult`1[[FinancingSystemDefinitions.Api.Contract.ContractWithCalculationResultDto, FinancingSystemDefinitions]], FinancingSystemDefinitions',
    Success: true,
    ErrorMessage: '',
    Data: {
      Contract: {
        ContractType: 1,
        Period: data.calculator.loanTerms,
        shouldSendToBytelab: false,
        Id: id,
        Buyer: {
          CustomerType: 0,
          Newsletter: false,
          InsuranceConsent: false,
          Person: {
            Id: 41010,
            FirstName: data.customerDetails.firstName,
            LastName: data.customerDetails.lastName,
            Address: data.customerDetails.address,
            POBox: '',
            ZipCode: data.customerDetails.zipCode,
            City: data.customerDetails.city,
            Phone: data.customerDetails.phoneNumber,
            Email: 'fleet.user@stacc.com',
            Initials: '',
            Other: '',
            Nationality: 61,
            Pid: '',
            Consent: {
              Type: 4,
              AllowDataPersistence: true,
              AllowAutomaticProcessing: true,
              Method: 5
            },
            DesiresBankChangeMeeting: false,
            IsContinuingEmployment: false,
            AgesOfChildrenInHousehold: [],
            VehiclesInHousehold: [],
            RegisterForPBS: false,
            EmploymentNo: ''
          },
          Organisation: {
            Id: 20341,
            Name: 'NOVO NORDISK A/S',
            VATnr: '24356454',
            Address: 'Novo Alle 1',
            POBox: '',
            ZipCode: '2880',
            City: 'Bagsværd',
            Country: '',
            Phone: '12345678',
            Fax: '',
            Email: '',
            Website: '',
            CreditorNumber: '',
            CompanyType: '',
            CoOrAtt: '',
            ContactPersonName: '',
            ContactPersonCPR: '',
            ContactPersonEmail: '',
            BranchekodeNummer: '',
            VirkCompanyType: 0,
            RegisterForPBS: false
          },
          UseDigitalSigning: false
        },
        Driver: {
          Id: 41011,
          FirstName: 'Hans Christian',
          LastName: 'Nielsen',
          Address: 'Sct. Clemens Torv 8',
          POBox: '',
          ZipCode: '8000',
          City: 'Aarhus C',
          Phone: '12345678',
          Email: 'flaade.bruger@bytelab.dk',
          Initials: '',
          Other: '',
          Nationality: 61,
          Pid: '',
          Consent: {
            Type: 4,
            AllowDataPersistence: true,
            AllowAutomaticProcessing: true,
            Method: 5
          },
          DesiresBankChangeMeeting: false,
          IsContinuingEmployment: false,
          AgesOfChildrenInHousehold: [],
          VehiclesInHousehold: [],
          RegisterForPBS: false,
          EmploymentNo: ''
        },
        Seller: {
          Person: {
            Id: 1337,
            FirstName: 'Fleet',
            LastName: 'User',
            Address: '',
            POBox: '',
            ZipCode: '',
            City: '',
            Phone: '',
            Email: 'torh@stacc.com',
            CPR: '',
            Initials: '',
            Nationality: 61,
            Pid: '',
            Consent: {
              Type: 4,
              AllowDataPersistence: true,
              AllowAutomaticProcessing: true,
              Method: 5
            },
            DesiresBankChangeMeeting: false,
            IsContinuingEmployment: false,
            AgesOfChildrenInHousehold: [],
            VehiclesInHousehold: [],
            RegisterForPBS: false,
            EmploymentNo: ''
          },
          Organisation: {
            Id: 1,
            Name: 'Stacc Bytelab',
            VATnr: '26305616',
            Address: 'Skt. Clemens Torv 8',
            POBox: '',
            ZipCode: '8000',
            City: 'Aarhus C',
            Country: '',
            Phone: '12345678',
            Fax: '',
            Email: 'post@bytelab.dk',
            Website: '',
            CreditorNumber: '',
            CompanyType: '',
            CoOrAtt: '',
            ContactPersonName: '',
            ContactPersonCPR: '',
            ContactPersonEmail: '',
            BranchekodeNummer: '',
            VirkCompanyType: 0,
            RegisterForPBS: false
          },
          UseDigitalSigning: false
        },
        Supplier: {
          Person: {
            Id: 0,
            FirstName: '',
            LastName: '',
            FullAddress: '',
            Address: '',
            HouseNumber: '',
            FloorNumber: '',
            DoorNumber: '',
            POBox: '',
            ZipCode: '',
            City: '',
            Phone: '',
            CellPhone: '',
            Email: '',
            CPR: '',
            Initials: '',
            DesiresBankChangeMeeting: false,
            IsContinuingEmployment: false,
            RegisterForPBS: false
          },
          Organisation: {
            Id: 0,
            Name: '',
            VATnr: '',
            FullAddress: '',
            Address: '',
            HouseNumber: '',
            FloorNumber: '',
            DoorNumber: '',
            POBox: '',
            ZipCode: '',
            City: '',
            Country: '',
            Phone: '',
            CellPhone: '',
            Fax: '',
            Email: '',
            Website: '',
            CreditorNumber: '',
            CompanyType: '',
            CoOrAtt: '',
            ContactPersonName: '',
            ContactPersonCPR: '',
            ContactPersonEmail: '',
            BranchekodeNummer: '',
            RegisterForPBS: false
          },
          UseDigitalSigning: false
        },
        DeliveryCompany: {
          Organisation: {
            Id: 10057,
            Name: 'Bents Biler & Buler ApS',
            VATnr: '45568956',
            Address: 'Bilvej 66',
            POBox: '',
            ZipCode: '8000',
            City: 'Aarhus C',
            Country: '',
            Phone: '',
            Fax: '',
            Email: '',
            Website: '',
            CreditorNumber: '',
            CompanyType: '',
            CoOrAtt: '',
            ContactPersonName: '',
            ContactPersonCPR: '',
            ContactPersonEmail: '',
            BranchekodeNummer: '',
            RegisterForPBS: false
          },
          UseDigitalSigning: false
        },
        Leasing: {
          UseFlexLeasing: false,
          FlexLeasingRegistrationFeePeriodStart: '0001-01-01T00:00:00',
          FlexLeasingRegistrationFeePeriodEnd: '0001-01-01T00:00:00',
          L64: true,
          L64Months: 37,
          FinanceFees: true,
          IsFinansialLeasing: false,
          Downpayment: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: data.calculator.downPayment
          },
          DownpaymentAsPercentage: 0,
          ProfileId: 15,
          UseImmediateDealerInterestPayment: false,
          Deposit: 0,
          DeliveryFee: 2960,
          LicensePlateFee: 1180,
          AnnualMileage: 15000,
          TireDealType: 2,
          WinterTireDeal: {
            Id: 33490,
            OptionType: 7,
            Price: 0,
            PriceIncVat: 0,
            Name: 'Winter tires',
            ProductCode: 'Winter tires',
            Supplier: {
              Id: 0,
              Name: '',
              VATnr: '',
              FullAddress: '',
              Address: '',
              HouseNumber: '',
              FloorNumber: '',
              DoorNumber: '',
              POBox: '',
              ZipCode: '',
              City: '',
              Country: '',
              Phone: '',
              CellPhone: '',
              Fax: '',
              Email: '',
              Website: '',
              CreditorNumber: '',
              CompanyType: '',
              CoOrAtt: '',
              ContactPersonName: '',
              ContactPersonCPR: '',
              ContactPersonEmail: '',
              BranchekodeNummer: '',
              RegisterForPBS: false
            },
            IsAvailable: false,
            IsSelected: false
          },
          Insurance: {
            UseInsurance: true,
            ConfigurationId: 1,
            Values: []
          },
          TCOPeriod: 36,
          TCOMileage: 15000,
          PublicAuthToken: '2b53da8d-45fd-4acb-9ec5-313d9cba5b79',
          InsurancePolicyNumber: '654745875',
          InsuranceCompany: 'If forsikring',
          InsuranceCompanyCvr: '22558822',
          AdministrationFeeFinanced: false,
          OwnerAfterLeasing: {
            OwnerAfterLeasingType: 0
          }
        },
        Guarantors: [],
        Signatories: [],
        Vehicle: {
          Id: data.assetDetails.regNo,
          VehiclePricingId: 11719,
          Price: 285000,
          ResidualValueIsInclVat: false,
          Options: [
            {
              Id: 5397,
              OptionType: 1,
              Price: 0,
              PriceIncVat: 0,
              Name: 'Deep Ocean Blue lak',
              ProductCode: '0P0P',
              OptionCategory: 2,
              IsAvailable: false,
              IsSelected: true,
              DisplayName: 'Deep Ocean Blue lak'
            },
            {
              Id: 2278,
              OptionType: 4,
              Price: 0,
              PriceIncVat: 0,
              MonthlyPrice: 100,
              Name: 'Road assistance',
              ServiceOptionType: 2,
              ProductCode: 'RA851',
              MonthlyPriceVatPrice: {
                MixedVat: 100,
                ExVat: 100,
                Vat: 25,
                IncVat: 125
              },
              IsAvailable: false,
              IsSelected: true,
              DisplayName: 'Road assistance'
            }
          ],
          CustomPrefittedOptions: [],
          CustomRetrofittedOptions: [],
          CustomPrefittedRimOptions: [],
          CustomRetrofittedRimOptions: [],
          LogicallyDisabledOptions: [],
          Rim: 0,
          Color: {
            Id: 5397,
            OptionType: 1,
            Price: 0,
            PriceIncVat: 0,
            Name: 'Deep Ocean Blue lak',
            IsAvailable: false,
            IsSelected: false
          },
          ImageUrl: data.assetDetails.imageUrl,
          EnergyClassId: 8,
          EnergyClass: 'F',
          CO2: 248,
          ParticleFilter: true,
          Specifications:
            '2 højttalere, Fartpilot, Varerumsmål: længde (mm): 3.500, bredde (mm): 2.040, bredde mellem hjulkasserne mm): 2.040, højde (mm): 400, læssehøjde (mm): 1.005 og producentens egne tal, Instrumentering: analogue & TFT, Gulvbelægning af plast/gummi, Halogenforlygter  med komplekse linser halogen, Pick-up lad: lige sider, Lokale sprog Dansk, Volkswagen, Crafter, 35 2.0TDI 102HK L3 og 35 2.0TDI 102HK L3, Bluetooth, Airbags 1',
          ABSBrakes: false,
          IntegratedChildSeats: 0,
          Airbags: 1,
          ESP: true,
          Radio: false,
          HorsePower: 102,
          FirstRegistrationDate: data.assetDetails.registrationDate,
          VehicleTypeId: 2,
          BilInfoVehicleType: 0,
          IsManualCar: false,
          ManualCarRegistrationFee: 0,
          ManualCarResidualValueMatrixId: 34177,
          ManualCarServiceMatrixId: 24102,
          ManualCarTireMatrixId: 34180,
          IsRegistrationFeePaidFor: true,
          VariantName: data.assetDetails.variant,
          ModelName: data.assetDetails.model,
          BrandName: data.assetDetails.make,
          ModelYear: Number(data.assetDetails.modelYear),
          Doors: 2,
          Range: 10.6,
          EuRange: 10.6,
          EuRangeMeasurementMethod: 3,
          EngineType: 'Diesel',
          EngineTypeEnum: 1,
          FuelType: 1,
          EngineSize: '2,0',
          Weight: 3500,
          PurchasePrice: 285000,
          LicensePlateType: 2,
          ExternalId: 423142,
          IsUsed: false,
          HasServiceBook: false,
          HasServiceMatrix: true,
          TimingBeltReplaced: 0,
          HasKmWarranty: false
        },
        WitnessesToTheSignature: [],
        ContractMessages: [],
        ContactInformation: {},
        FinancialPartner: 'Stacc AS',
        IsLocked: false,
        CreationDate: new Date().toISOString(),
        StartDate: new Date().toISOString(),
        DeliveryDate: '2025-02-22T00:00:00+01:00',
        UserPreferredDeliveryDate: '22-02-2025',
        DeliveryLocation: 0,
        AdditionalDealerInterest: 0,
        OfferId: 20834,
        OfferFleetCustomerStatus: 6,
        ContractId: 20834,
        ContractStatus: 3,
        InterestType: 1,
        Interest: 5.5,
        InitialFee: 2995,
        AdministrationFee: 30,
        AdministrationFeeNoPBS: 75,
        SalesChannelGuid: '7c9e6679-7425-40de-944b-e07fc1f90ae7',
        CustomerTermsOrganisationId: 10042,
        CustomerTermsUserId: 3023,
        CarpolicyId: 17,
        IsFleetContract: true,
        CustomServiceOptionDictionary: {},
        ContractExpirationDate: '2027-03-01T00:00:00+01:00',
        IsCalculationOnly: false,
        IsWithoutPersonalInformation: false,
        HasEskatBeenCreated: false,
        UseESkat: false,
        AttachedDocuments: [],
        GeneratedDocuments: [
          {
            DocumentType: 1,
            DocumentId: 22030,
            FileName: '20834 - Quote- Volkswagen Crafter - Hans Christian Nielsen.pdf',
            DownloadDocumentUrl: '/Views/Documents/GetPDFDocument.aspx?id=22030'
          }
        ],
        PublicAuthToken: '2b53da8d-45fd-4acb-9ec5-313d9cba5b79'
      },
      CalculationResult: {
        Leasing: {
          TotalMonthlyPayment: 4878.8,
          TCOPrKm: 4.83,
          TCOMonthly: 7553.38,
          OwnerFee: 6120,
          TaxValueInclVat: 408130,
          CompletePaymentWithoutInsuranceAndOwnerfee: 176724,
          Id: 20725,
          CalculationId: 'b252bce1-a278-471c-b8fb-9064d977e0bc',
          RegistrationFee: Number(data.calculator.registrationFee),
          ResidualValue: Number(data.calculator.calculatedResidualValue),
          MonthlyService: 220,
          InsuranceAdministration: 960,
          FortjenestePåDækVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåDækIProcent: 0,
          FortjenestePåErstatningsbilVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåErstatningsbilIProcent: 0,
          FortjenestePåForsikringVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåServiceVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåServiceIProcent: 0,
          FortjenestePåAndreTillægsydelserVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåAndreTillægsydelserIProcent: 0,
          FortjenestePåVejhjælpVatPrice: {
            MixedVat: 3600,
            ExVat: 3600,
            Vat: 900,
            IncVat: 4500
          },
          FortjenestePåVejhjælpVatPriceIProcent: 0,
          FortjenestePåBrændstofkortVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          FortjenestePåBrændstofkortIProcent: 0,
          L64Interest: 5.5,
          L64PrePaidRegFee: 18565,
          L64RestRegFee: 28435,
          L64RestRegFeeIntrestAmount: 4822.1,
          L64WriteOffPercent: 0.4,
          LeaseCompanyCommisionMarkup: 0,
          LeasingInterestMarkupTotalValue: 8775.41,
          ResidualValuePercent: 71,
          TotalRegistrationFee: 47000,
          TotalResidualValueInclRegfee: 202350,
          VehicleIncRegFeeResidualValueVatPrice: {
            MixedVat: 202350,
            ExVat: 202350,
            Vat: 50587.5,
            IncVat: 252937.5
          },
          VehicleResidualValueVatPrice: {
            MixedVat: 202350,
            ExVat: 202350,
            Vat: 50587.5,
            IncVat: 252937.5
          },
          SplitpaymentActive: false,
          Deposit: 0,
          DepositInterest: 5.5,
          DepositInterestAmount: 0,
          DepositTotalInterestAmount: 0,
          CustomResidualValueDeviationPercentageLimit: 10,
          MinimumResidualValueLimit: 2850,
          MinimumResidualValuePercentageLimit: 1,
          VehicleOptionsLicencePlateDeliverySubidiesAndTotalRegFeeVatPrice: {
            MixedVat: 336140,
            ExVat: 336140,
            Vat: 71990,
            IncVat: 408130
          },
          DeliveryVatPrice: {
            MixedVat: 2960,
            ExVat: 2960,
            Vat: 740,
            IncVat: 3700
          },
          ShippingCostVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          VatDeductionPre36Monthly: 235,
          VatDeductionPost36Monthly: 117.5,
          VatDeductionPeriods: [
            {
              FromMonth: 1,
              ToMonth: 36,
              VatDeduction: 1227.201077701
            }
          ],
          DownpaymentPercentageFee: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          GrundlagForAarligtMiljoetillaeg: 7120,
          AarligtMiljoetillaeg: 42720,
          AarligeMiljoetillaegList: [
            {
              Year: 2024,
              Price: 42720
            },
            {
              Year: 2025,
              Price: 53060
            },
            {
              Year: 2026,
              Price: 58380
            },
            {
              Year: 2027,
              Price: 58380
            }
          ],
          AboveKmPrice: 3,
          AboveKmPriceInclVat: 3.75,
          AdministrationFee: 30,
          AdministrationFeeNoPBS: 75,
          AverageMonthlyVatDeduction: 1227.2,
          AverageMonthlyVatDeductionFirst48Month: 0,
          BelowKmPrice: 0.5,
          BelowKmPriceInclVat: 0.63,
          CalculatedTotalInterest: 5.5,
          CompletePayment: 233126.35,
          CompleteVehicleOwnerFee: 36720,
          DealerInterestMarginSum: 0,
          ExternalCommission: 0,
          FinacedAmount: 312527.1,
          TotalFinancingSum: Number(data.calculator.purchasePrice) - Number(data.calculator.downPayment),
          InitialFee: 2995,
          Interest: Number(data.calculator.nominalInterestRate),
          InterestSale: 5.5,
          InterestSaleTotal: 5.5,
          InvoicePrice: 0,
          L64InterestDate: '2021-01-01T00:00:00+01:00',
          L64UpfrontPayment: 23387.1,
          LeasingInterestMarkupPerMonthValue: 243.76,
          MonthlyInterestInCurrency: 1174.45,
          MonthlyPaymentAdministrationFee: {
            MixedVat: 30,
            ExVat: 30,
            Vat: 7.5,
            IncVat: 37.5
          },
          MonthlyPaymentColorOptionsVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          MonthlyPaymentDealerFittedOptionsVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          MonthlyPaymentFactoryFittedOptionsVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          MonthlyPaymentInsuranceVatPrice: {
            MixedVat: 500,
            ExVat: 500,
            Vat: 0,
            IncVat: 500
          },
          MonthlyPaymentReplacementCarVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          MonthlyPaymentRoadAssistanceVatPrice: {
            MixedVat: 100,
            ExVat: 100,
            Vat: 25,
            IncVat: 125
          },
          MonthlyPaymentServiceOptionsVatPrice: {
            MixedVat: 118.88,
            ExVat: 118.88,
            Vat: 29.72,
            IncVat: 148.6
          },
          MonthlyPaymentServiceVatPrice: {
            MixedVat: 220,
            ExVat: 220,
            Vat: 55,
            IncVat: 275
          },
          MonthlyPaymentTireDealVatPrice: {
            MixedVat: 205,
            ExVat: 205,
            Vat: 51.25,
            IncVat: 256.25
          },
          MonthlyPaymentVehicleVatPrice: {
            MixedVat: 4234.92,
            ExVat: 4234.92,
            Vat: 1058.73,
            IncVat: 5293.66
          },
          MonthlyServiceAndTireDealIncVat: 425,
          MonthlyServiceIncVat: 275,
          MonthlyServiceOptions: 0,
          MonthlyServiceOptionsIncVat: 0,
          MonthlyTireDealPrice: 205,
          MonthlyTurnover: 4234.92,
          MonthlyTurnoverOptions: 0,
          MonthlyTurnoverOptionsIncVat: 0,
          MonthlyTurnoverVehicle: 4234.92,
          PeriodStep: 0,
          PrePayment: 0,
          PrePaymentPercentOfVehiclePrice: 0,
          PrePaymentVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          PrimaryTirePricePerKm: 14,
          Provision: 0,
          RegFeeInPeriod: 23387.1,
          ResidualValueVAT: 50587.5,
          SubscriptionMonthlyPayment: 0,
          SubscriptionMonthlyPaymentVat: 0,
          SuggestedResidualValue: {
            MixedVat: 202350,
            ExVat: 202350,
            Vat: 50587.5,
            IncVat: 252937.5
          },
          TaxValueInclVatMonthly: 11292.38,
          NettoTaxValueInclVatMonthly: 5646.19,
          TaxValueInclVatYearly: 135508.6,
          TCO: 326289.59,
          TCOFuelPriceDiesel: 12,
          TCOFuelPriceGasoline: 13,
          TCOFuelUsageMonthly: 1415.09,
          TCOInsuranceEstimateMonthly: 500,
          TCOInPeriod: 271921.68,
          TcoOwnerFeeMonthly: 0,
          TcoExceededSalaryNetDeduction: 0,
          TotalAdministrationFee: 4075,
          TotalDealerCommission: 0,
          TotalDealerProfit: 0,
          TotalFeesAndInsuranceAdministration: 3955,
          TotalMonthlyPaymentInclVat: Number(data.calculator.purchasePrice) / data.calculator.loanTerms,
          TotalMonthlyPaymentStep: 0,
          TotalMonthlyPaymentVat: 1219.7,
          TotalMonthlyPaymentVehicleIncVatExService: 5823.51,
          TotalProfit: 8775.41,
          TotalResidualValue: Number(data.calculator.calculatedResidualValue),
          varPriceVehiclePriceLicencePlateDeliverySubidiesAndRegFee: 312527.1,
          VehicleAgeAtLeasingStartMonths: 0,
          VehicleMonthlyPayment: 4878.8,
          VehicleMonthlyPaymentExOptions: 4353.8,
          VehicleMonthlyPaymentExOptionsVat: 0,
          VehicleMonthlyPaymentExOptionsVatPrice: {
            MixedVat: 4353.8,
            ExVat: 4353.8,
            Vat: 1088.45,
            IncVat: 5442.26
          },
          VehicleMonthlyPaymentVat: 0,
          VehiclePriceIncOptionsIncRegFeeIncVAT: 403250,
          VehiclePriceLicencePlateDeliveryAndSubidies: 289140,
          VehiclePriceLicencePlateDeliveryAndSubidiesIncVAT: 361130,
          VehiclePriceLicencePlateDeliveryAndSubidiesVAT: 71990,
          VehiclePriceLicencePlateDeliverySubidiesAndTotalRegFee: 336140,
          VehiclePriceLicencePlateDeliverySubidiesAndTotalRegFeeIncVAT: 408130,
          VehiclePriceLicencePlateDeliverySubidiesAndTotalRegFeeVAT: 71990,
          VehiclePriceSubidiesAndRegFeeInPeriod: 308387.1,
          VehiclePriceSubidiesAndRegFeeInPeriodIncVAT: 379637.1,
          VehiclePriceSubidiesAndRegFeeInPeriodVAT: 71250,
          WinterTirePricePerKm: 20,
          YearlyOwnerFee: 12240,
          OptionsLimitExceeded: false,
          TotalPrefittedOptionsInclRegFeeVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          TotalRetrofittedOptionsVatPrice: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          MonthlyPaymentHiddenServiceOptionsVatPrice: {
            MixedVat: 100,
            ExVat: 100,
            Vat: 25,
            IncVat: 125
          },
          TotalMileageDuringPeriod: 0,
          VehicleReturnFee: {
            MixedVat: 0,
            ExVat: 0,
            Vat: 0,
            IncVat: 0
          },
          TotalMonthlyPaymentVatPrice: {
            MixedVat: 4878.8,
            ExVat: 4878.8,
            Vat: 1219.7,
            IncVat: 6098.51
          },
          FuelUsageMonthlyVatPrice: {
            MixedVat: 1415.09,
            ExVat: 1132.08,
            Vat: 283.02,
            IncVat: 1415.09
          },
          AFradrag: 0,
          BFradrag: 66960,
          AnnualMileage: 15000,
          LeasingPeriod: data.calculator.loanTerms
        },
        StandardTireOptionPrice: 0,
        MonthlyPaymentDetails: [],
        DownpaymentDetails: [],
        ValidationMessages: []
      }
    },
    ValidationErrors: [],
    RedirectURL: ''
  }

  return testBody
}
